<form [formGroup]="formGroup"
      class="checkbox"
      *transloco="let t">
  <div class="checkbox-label">
    <mat-checkbox color="primary"
                  [formGroup]="formGroup"
                  [formControlName]="abstractFormControlName"
                  [ngClass]="{error: control.dirty && control.invalid}">
    </mat-checkbox>
    <app-label [isGray]="!anchorTermsLink || !anchorPrivacyLink">
      <ng-content *ngIf="!anchorTermsLink && !anchorPrivacyLink"></ng-content>
      <ng-container *ngIf="anchorTermsLink && anchorPrivacyLink">
        {{ label }} <br>
        <app-anchor target="_blank">
          {{ anchorPrivacyText }}
        </app-anchor>
      </ng-container>
    </app-label>
  </div>
  <div class="break"></div>
  <mat-error *ngIf="control.dirty && control.invalid">
    {{ t(requiredErrorText) }}
  </mat-error>
</form>
